module.exports = __webpack_public_path__ + "assets/images/project/constituencies/east-coast-grc.jpg?v=7f1090e6";